/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Web services
 */
@Injectable({
  providedIn: 'root',
})
export class WebConfiguration {
  rootUrl: string = 'http://localhost:8090/web';
}

export interface WebConfigurationInterface {
  rootUrl?: string;
}
